import React, { useState, useEffect, useCallback } from "react";

import {
  SemanticTable,
} from "./styles";
import { Button } from "semantic-ui-react";

const MBA = props => {
  const [titulo, setTitulo] = useState(props.mba.curso.curso);
  const [idCurso, setIdcurso] = useState(props.mba.id_curso);

  useEffect(() => {
    setTitulo(props.mba.curso.curso);
    setIdcurso(props.mba.id_curso);
  }, [props.mba]);

  return (
    <>
      <SemanticTable.Row>
        <SemanticTable.Cell>
          {titulo} [{idCurso}]
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          <>
            <Button
              icon="trash icon"
              info="delete"
              title="Excluir matrícula neste curso"
              onClick={() => props.delete()}
            />
            <Button
              icon="edit icon"
              info="Editar"
              title="Editar MBA do Aluno"
              as="a"
              href={`/admin/mba/list/${props.mba.id}`}
              target="_blank"
            />
          </>
        </SemanticTable.Cell>
      </SemanticTable.Row>
    </>
  );
};

export default MBA;
